module.exports = __webpack_public_path__ + "img/rpm.fe588b0c.svg";